const mutations = {
  SET_BLOCKED (state, { blocked }) {
    state.blocked = blocked
  }
}

export default mutations
